import { z } from 'zod'

import { optional, required } from './schemaHelpers'

/**
 * Schema Zod per un singolo servizio auto.
 *
 * Goelett richiede luogo e data di ritiro e la data di riconsegna (la Search non parte
 * con una finestra aperta): il noleggio è round-trip, quindi il luogo di riconsegna riusa
 * il ritiro, e orari/categoria/tipo/trasmissione non sono vincoli per la ricerca.
 *
 * @param {{ isGoelett?: boolean }} options
 */
export const buildCarServiceSchema = ({ isGoelett = false } = {}) => {
  const req = isGoelett ? optional : required
  return z.object({
    pickupPlace: required(),
    pickupDate: required(),
    pickupHour: req(),
    dropoffPlace: req(),
    dropoffDate: required(),
    dropoffHour: req(),
    carCategory: req(),
    carType: req(),
    carTransmission: req(),
    noteAggiuntive: optional()
  })
}
